var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-viewer',{staticClass:"grey darken-2"},[_c('Navbar'),_c('v-container',{staticClass:"d-flex align-center",staticStyle:{"height":"calc(100% - 77px)"}},[_c('v-row',{attrs:{"justify":"center"}},[_c('router-view')],1)],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }